// Shared constants for the PadSplit message-send outage experience.
//
// Two surfaces consume these:
//   1. The per-failure pop-up shown when a host→PadSplit send fails
//      (client/src/components/padsplit-send-error-dialog.tsx).
//   2. The admin-toggled global outage banner that replaces every outbound
//      compose box (client/src/components/messaging-outage-banner.tsx) plus the
//      server-side guard on the manual send routes.
//
// The link points hosts at PadSplit's own host communication page so they can
// keep messaging members directly while PadPulse sending is degraded.

export const PADSPLIT_DIRECT_MESSAGE_URL =
  "https://www.padsplit.com/host/communication";

// Admin-toggled global banner copy (Feature 2).
export const MESSAGING_OUTAGE_BANNER_TEXT =
  "We're sorry for the temporary outage. Click here to send messages directly through PadSplit.";

// Server-guard response message when the admin outage toggle is ON. Matches the
// banner copy so a bypassed/stale client still surfaces consistent wording.
export const MESSAGING_OUTAGE_GUARD_MESSAGE = MESSAGING_OUTAGE_BANNER_TEXT;

// Per-failure pop-up copy (Feature 1).
export const PADSPLIT_SEND_ERROR_TITLE = "We couldn't send your message";
export const PADSPLIT_SEND_ERROR_BODY =
  "PadPulse is having a temporary issue sending messages. Please send your message directly through PadSplit while we get this fixed.";

// Error/response code returned by the server when the admin outage toggle is ON.
export const MESSAGING_OUTAGE_CODE = "MESSAGING_OUTAGE";

// Error code the send routes return on a PadSplit delivery failure.
export const PADSPLIT_SEND_FAILED_CODE = "PADSPLIT_SEND_FAILED";
